import "../../styles/sections/header.scss";

class Header extends HTMLElement {
  constructor() {
    super();

    this.announcementBar = document.querySelector(".announcement-bar");
    this.announcementBarHeight = 0;

    this.isHeaderSticky = this.classList.contains("header--sticky");
    this.openMenuButton = this.querySelector("[data-open-nav]");
    this.allSubmenus = this.querySelectorAll("[data-has-submenu]");
    this.nav = this.querySelector("[data-nav]");
    this.closeNav = this.querySelector("[data-close-nav]");
    this.backdrop = this.querySelector("[data-backdrop]");
    this.allLevelTwoMenus = this.querySelectorAll(".header__menu-level-2");

    if (this.isHeaderSticky) {
      window.addEventListener("DOMContentLoaded", () => {
        this.calculateAnnouncementHeight();
      });

      window.addEventListener("resize", () => {
        this.calculateAnnouncementHeight();
      });

      this.setStickyObserver();
    }

    this.openMenuButton.addEventListener("click", () => {
      this.toggleNav();
    });

    this.closeNav.addEventListener("click", () => {
      this.toggleNav();
    });

    this.backdrop.addEventListener("click", () => {
      this.toggleNav();
    });

    this.allSubmenus.forEach((submenu) => {
      submenu.addEventListener("click", (e) => {
        this.clickSubmenuLink(e);
      });
    });
    
    this.allLevelTwoMenus.forEach((subMenu) => {
      subMenu.addEventListener("mouseover", (e) => {
        subMenu.parentElement.classList.add(
          "header__menu-item-submenu-selected"
        );
      });

      subMenu.addEventListener("mouseout", (e) => {
        subMenu.parentElement.classList.remove(
          "header__menu-item-submenu-selected"
        );
      });
    });
  }

  setStickyObserver() {
    const el = document.querySelector(".header");
    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle("sticked", e.intersectionRatio < 1),
      { threshold: [1] }
    );
    observer.observe(el);
  }

  calculateAnnouncementHeight() {
    this.announcementBarHeight = this.announcementBar.offsetHeight;
    document.documentElement.style.setProperty(
      "--announcement-height",
      `${this.announcementBarHeight}px`
    );
  }

  toggleNav() {
    document.body.classList.toggle("no-scroll");
    this.nav.classList.toggle("active");
    this.backdrop.classList.toggle("active");
  }

  toggleSubmenu(e) {
    const link = e.target.closest(".header__menu-item-link");
    const menu = link
      .closest(".header__menu-item")
      .querySelector("[data-child-menu]");

    link.classList.toggle("js-active");
    menu.classList.toggle("js-active");
  }

  clickSubmenuLink(e) {
    const linkTarget = e.target.closest(".header__menu-item-link");

    if (
      e.target.classList.contains("header__menu-item-toggler") ||
      (window.matchMedia("(max-width: 1199px)").matches &&
        !linkTarget.classList.contains("js-active"))
    ) {
      e.preventDefault();
      this.toggleSubmenu(e);
    }
  }
}

customElements.define("site-header", Header);

class CartLink extends HTMLElement {
  constructor() {
    super();

    this.cartLink = this.querySelector("[data-cart-link]");

    this.cartLink.addEventListener("click", (event) => {
      event.preventDefault();

      window.dispatchEvent(new Event("dynamic-cart-open"));
    });

    window.addEventListener("ajax-cart", (event) => {
      if (event.detail.items.length) {
        this.classList.add("header__nav-button--cart-not-empty");
      } else {
        this.classList.remove("header__nav-button--cart-not-empty");
      }
    });
  }
}

customElements.define("cart-link", CartLink);
